import GenericCable from "./GenericCable";

export default class CatalogueExport extends GenericCable {
  async open() {
    super.open("CatalogueExportChannel");
  }
}
